import api from '../../apiConfig/apiConfig';
import { Post, Get } from '../base/baseAjax';

//开启关闭插件
let getplugin = param => {
	return Get({
		url: api.chat.getplugin + param.id,
	});
};
//推送主页Id
let getpushhome = param => {
	return Post({
		url: api.chat.getpushhome + param.id,
	});
};

//插件启动状态列表
let getallconfig = param => {
	return Post({
		url: api.chat.getallconfig,
		bodyParam: param,
	});
};

//基础设置、问候语、开始对话、常见问题保存修改
let getfabasic = param => {
	return Post({
		url: api.chat.getfabasic + '?' + 'serviceSiteId=' + param.serviceSiteId,
		bodyParam: param,
	});
};

//获取即时聊天配置信息
let getfbconfig = param => {
	return Post({
		url: api.chat.getfbconfig,
		bodyParam: param,
	});
};

//获取插件配置率
let getSetRate = param => {
	return Get({
		url: api.chat.getSetRate,
	});
};

// 配置页面重置
let configReset = param => {
	return Post({
		url: api.chat.configReset + param.id + '?' + 'serviceSiteId=' + param.serviceSiteId,
		bodyParam: param,
	});
};

//配置发布
let publishconfig = param => {
	return Post({
		url: api.chat.publishconfig,
		bodyParam: param,
	});
};

//获取渠道是否可以操作
let getChannelstatus = param => {
	return Post({
		url: api.chat.getChannelstatus,
		bodyParam: param,
	});
};

//获取总开关状态
let getMainSwitchstatus = param => {
	return Post({
		url: api.chat.getMainSwitchstatus,
		bodyParam: param,
	});
};

//开关或关闭总开关
let setMainSwitch = param => {
	return Post({
		url: api.chat.setMainSwitch,
		bodyParam: param,
	});
};

//获取AI自动回复配置
let getAIReplyConfig = param => {
	return Post({
		url: api.chat.getAIReplyConfig,
		UrlParam: param,
	});
};

//设置AI自动回复配置
let setAIReplyConfig = param => {
	return Post({
		url: api.chat.setAIReplyConfig,
		bodyParam: param,
		UrlParam: { serviceSiteId: param.serviceSiteId },
	});
};

export default {
	getplugin,
	getpushhome,
	getfabasic,
	getfbconfig,
	getSetRate,
	getallconfig,
	publishconfig,
	configReset,
	getChannelstatus,
	getMainSwitchstatus,
	setMainSwitch,
	getAIReplyConfig,
	setAIReplyConfig,
};
